<!--Description:树节点 包含菜单按钮-->
<!--
nodeName:【必填】节点名称
isShowBtn:【必填】是否显示菜单按钮 一般在选中节点时显示
@showContextMenu  点击显示菜单按钮执行的事件 默认参数event
-->
<template lang='pug'>
  span.custom-tree-node
    .text-overflow
      svg-icon.iconColor(:icon-class='iconClass', v-if='iconClass' style="margin-right: 5px")
      span.node-name(:title='nodeName') {{ nodeName }}
    i(:class='elIcon?elIcon:"el-icon-more"', @click.stop='showMenu', v-show='isShowBtn')
</template>

<script>
export default {
  name: 'treeNode',
  props: {
    nodeName: {
      type: String
    },
    isShowBtn: {
      type: Boolean
    },
    iconClass: {
      type: String
    },
    elIcon: {
      type: String,
      default: 'el-icon-more'
    }
  },
  data() {
    return {}
  },
  methods: {
    showMenu(e) {
      this.$emit('showContextMenu', e)
    }
  }
}
</script>

<style scoped lang="scss">
.custom-tree-node {
  width: 20px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
  .svg-icon {
    font-size: 15px;
  }
  .el-icon-more {
    font-size: 20px;
    color: #aaa;
    display: none;
  }
  .show {
    display: block;
  }
  &:hover {
    .el-icon-more {
      display: block;
    }
  }
}
</style>